package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.tabs.customer_card_tab.component.dialogs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.config.generalDialogSetting
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.TransactionColumnsEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.components.dialog.component.DialogTitle

@Composable
fun SelectTransactionColumnsDialog(
    windowSizeMode: WindowSizeModeEnum,
    onBackgroundClick: () -> Unit,
    onCloseDialog: () -> Unit,
    toggleTransactionColumn: (MutableSet<TransactionColumnsEnum>) -> Unit,
    initialTransactionColumns: Set<TransactionColumnsEnum>,

    )
{

    val tempSelectedColumns = remember {
        mutableStateOf(initialTransactionColumns.toMutableSet())
    }


    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                onBackgroundClick()
            }
    ){

        Column(
            modifier = Modifier
                .onClick {
                    event: SyntheticMouseEvent -> event.stopPropagation()
                }
                .align(Alignment.Center)
                .width(
                    if (windowSizeMode== WindowSizeModeEnum.PHONE)
                        Dimen.selectTransactionDialogPhoneWidth
                    else Dimen.selectTransactionDialogWidth
                )
                .height(
                    if (windowSizeMode== WindowSizeModeEnum.PHONE)
                        Dimen.selectTransactionDialogPhoneHeight
                    else Dimen.selectTransactionDialogHeight
                )
                .generalDialogSetting()
            ,
            horizontalAlignment = Alignment.CenterHorizontally
        ){
            DialogTitle(
                title = Strings.current().selectDesiredColumns,
                showCloseIcon = true
            ) {
                onCloseDialog()
            }

            Column(
                modifier = Modifier
                    .padding(Dimen.extraLargePadding)
                    .fillMaxWidth(),
                horizontalAlignment = Alignment.Start,

            ) {
                TransactionColumnsEnum.entries
                    .chunked(
                        if (windowSizeMode== WindowSizeModeEnum.PHONE) 2
                        else 3
                    ).forEachIndexed {rowIndex,rowItems->
                        Row(
                            modifier = Modifier
                                .margin(bottom = Dimen.largePadding),
                            horizontalArrangement = Arrangement.Start
                        )
                        {
                            rowItems.forEachIndexed{index,model->
                                CheckboxComponent(
                                    modifier = Modifier
                                        .width(
                                            if (windowSizeMode== WindowSizeModeEnum.PHONE)
                                                Dimen.transactionColumnItemPhoneWidth
                                            else Dimen.transactionColumnItemWidth
                                        ),
                                    checkStatus = tempSelectedColumns.value.contains(model),
                                    title = model.title,
                                    onChecked = {
                                        tempSelectedColumns.value.add(model)
                                    },
                                    onUnChecked = {
                                        tempSelectedColumns.value.remove(model)
                                    }
                                )
                            }

                        }

                    }

                Spacer()

                Box(
                    modifier = Modifier.fillMaxWidth()
                )
                {
                    CustomButton(
                        modifier = Modifier.align(Alignment.CenterEnd),
                        windowSizeMode = windowSizeMode,
                        title = Strings.current().submit,
                        buttonType = ButtonTypes.CONTAINED,
                        onButtonClick = {
                            toggleTransactionColumn(tempSelectedColumns.value)
                        }

                    )
                }

            }

        }

    }


}